/*
 * @Author: your name
 * @Date: 2022-01-21 09:33:24
 * @LastEditTime: 2022-04-11 10:13:39
 * @LastEditors: Please set LastEditors
 * @Description: 云盘接口
 * @FilePath: \management-admin\src\api\dataManager.js
 */
import request from "@/utils/request.js";

/**
 * @description: 文件夹树
 * @param {*} params 入参data
 * @return {*}
 */
export function folderList(params) {
  return request({
    url: "/closureTable/getChildren",
    method: "get",
    data: params
  });
}

/**
 * @description: 新建文件夹
 * @param {*} params 入参data
 * @return {*}
 */
export function folderAdd(params) {
  return request({
    url: "/closureTable/create",
    method: "post",
    params: params
  });
}

/**
 * @description: 删除文件夹
 * @param {*} params 入参data
 * @return {*}
 */
export function folderBatchDel(params) {
  return request({
    url: "/closureTable/delete",
    method: "delete",
    params: params
  });
}
/**
 * @description: 移动文件夹
 * @param {*} params 入参data
 * @return {*}
 */

export function folderMove(params) {
  return request({
    url: "/closureTable/move",
    method: "post",
    params: params
  });
}

/**
 * @description: 重命名文件夹
 * @param {*} params 入参data
 * @return {*}
 */
export function folderEdit(params) {
  return request({
    url: "/closureTable/update",
    method: "post",
    params: params
  });
}

/**
 * @description: 合并分片文件
 * @param {*} params 入参data
 * @return {*}
 */
export function MergeFragmentation(params) {
  return request({
    url: "/uploader/mergeFile",
    method: "post",
    // params: params,
    data: params
  });
}

/**
 * @description: 文件夹文件列表
 * @param {*} params 入参data
 * @return {*}
 */
export function fileList(params) {
  return request({
    url: `/uploader/fileList?id=${params.id}&order=${params.order}`,
    method: "get",
    data: params
  });
}

/**
 * @description: 移动文件
 * @param {*} params 入参data
 * @return {*}
 */
export function moveFile(params) {
  return request({
    url: "/uploader/moveFile",
    method: "post",
    // params: params,
    data: params
  });
}

/**
 * @description: 删除文件
 * @param {*} params 入参data
 * @return {*}
 */
export function deleteFile(params) {
  return request({
    url: "/uploader/deleteFile",
    method: "delete",
    // params: params,
    data: params
  });
}

/**
 * @description: 复制文件
 * @param {*} params 入参data
 * @return {*}
 */
export function copyFile(params) {
  return request({
    url: "/uploader/copyFile",
    method: "post",
    // params: params,
    data: params
  });
}

/**
 * @description: 搜索云盘文件
 * @param {*} params 入参data
 * @return {*}
 */
export function search(params) {
  return request({
    url: "/uploader/search?search=" + params.filename,
    method: "get"
  });
}

/**
 * @description: 文件重命名
 * @param {*} params 入参data
 * @return {*}
 */
export function fileReName(params) {
  return request({
    url: "/uploader/fileReName",
    method: "post",
    params: params
  });
}

/**
 * @description: 获取兄弟节点数组
 * @param {*} params 入参data
 * @return {*}
 */
export function siblingNode(params) {
  return request({
    url: "/closureTable/getSiblingNode?id=" + params.id,
    method: "get"
  });
}

/**
 * 压缩文件夹
 * @param {*} params
 * @returns true：正在压缩 false: 压缩完成
 */
export function zipFolder(params) {
  return request({
    url: "/uploader/zipFolder/" + params.id,
    method: "get"
  });
}

/**
 * 用于上传文件夹时，创建文件夹
 * @param {*} params
 * @returns
 */
export function generateFolderStructure(params) {
  return request({
    url: "/uploader/generateFolderStructure",
    method: "post",
    data: params
  });
}

/**
 * 一起看
 * @returns 返回房间信息
 */
export function room() {
  return request({
    url: "/websocket/room",
    method: "get"
  });
}
